export let Version = '1.6.0';


/*
version 1.6.0 20211119.1100
- BREAKING CHANGES
- added work order functionality

version 1.5.0 20201110.1700
- BREAKING CHANGES; Now using Angular 10
- Added Work order module, security enhancement on attachment download, persist state
- migrate from local helper to nglhelper
- optional encrypted QR code


version 1.4.0 20200227.1700
- BREAKING CHANGES; Now using Angular 9
- Added 3D modeling viewer to Echol Account for demo purpose. only applicable at Site 1 for now

version 1.3.3 20190611.1100
- Added account suspension feature (only sysadmin account able to suspend account)
- bulk import for RBV slight code change to handle space at front & back of row

version 1.3.3 20190607.1630
- Added account suspension feature (only sysadmin account able to suspend account)

version 1.3.2 20190529.0930
- Added JWT expiry checking
- Changed Token expiry to 1 day
- Bug fix on bulk import => incorrect error line number
- Bug fix on RBV Overall Status Summary report & universal overalltatussummary report Group filtering not working
- Bug fix on sitemap not showing RBV Overall Status Summary report
- Enhancement on RBV Overall Status Summary report, show filter value & generation pax + date in exported excel

version 1.3.1 20190523.1030
- Enhancement on indicating conducted action comes from web or mobile. (required new column on eventdata table. Update of APP is optional as backend cater for earlier version app)

version 1.3.0 20190522.1800
- Created individual new overall status summary report for RBV - added total num of panel column on each row
- Remove email from required field @ account management
- Bug fix on delete asset will be inserted as delete account in audit log's entity

version 1.2.2 20190502.1130
- Bug fix on bulk update status where unauthorized company can conduct bulk update action.
- Bug fix on asset list query if a dynamic field which need to join table chosen to show in table will cause query error
- Enhancement on guidebook download : Will now download file with actual name instead of id as name
- Enhancement on guidebook view : Now only PDF format can view on screen, previously other filetype will show view icon too but in fact not viewable.


version 1.2.1 20190314.1200
+ Changes on Overall Status Summary report - filterable and compatible with both 'Mult' or 'Single' site setup
- Enhance on some modules where in readonly mode unable to view detail, only can see the list which is not right.
+ Asset Group readonly mode is now showing a table for selected target. Only when full access mode is hshowing the selection panel
- Bug fix on readonly mode can delete uploaded file and unable to see original size of uploaded photo
+ Added Delete asset API which is left out all the time


version 1.2.0 20190312.1700
- Company is now configurable label
- QR Code template becomes dynamic and pull from DB
- Added bulk update capability (required setting 'Bulk Update: true' @ db table:process_step & Site Setup Allow Bulk Update)
- Include bug fix from Contech to remove deleted asset from daily production report


version 1.1.1
- Fix OverallSummary Report where rejected status will be counted as success if an asset with rejected status continue with next action
- Added reset button to remove ddl value for dynamic form ddl
- fix a bug in mobile app backend where siteId is not included when retrieve status


version 1.1.0
- Added 2 reports for POKBJV
- Login UI changed
- Site is now can be differentiated with Single asset type or Multi Asset type
- SN can be system generated with user defined prefix(prefix format configurable in DB) or free text input
- Added asset group as filters
- New shell tab to download & view PDF


version 1.0.4
- modify asset management related access control so that can view but cannot edit
- modify administrative/account module so that only same company & company below its hierarchy can see related account
- added super admin rights, he can change asset action statusfreely to whichever step
*/
